(window.AvailablePositions = function (Behaviors) {

  "use strict";
  
  function AvailablePositions(elem) {
    Behaviors.init(AvailablePositions, this, arguments)

    this.container = this.$elem[0];

    //Main Tabs
    this.container.querySelectorAll('.careers__sidebar-list-item').forEach(item => {
      item.addEventListener('click', (e)=> {
        if (this.container.querySelector('.careers__sidebar-list-item--active')) {
          this.container.querySelector('.careers__sidebar-list-item--active').classList.remove('careers__sidebar-list-item--active');
        }
        e.currentTarget.classList.add('careers__sidebar-list-item--active');

        let tab = e.currentTarget.dataset.target;
        if (this.container.querySelector('.careers__tab--active')) {
          this.container.querySelector('.careers__tab--active').classList.remove('careers__tab--active');
        }
        this.container.querySelector(`[data-tab="${tab}"]`).classList.add('careers__tab--active');
      });

    });
    
    document.querySelector('.careers__sidebar-list li:first-child').click();
   
  }

  Behaviors.inherit(AvailablePositions, Behaviors.Behavior);
  AvailablePositions.QUERY = '.careers';

  Behaviors.register_behavior(AvailablePositions);
  
  return AvailablePositions;

  }(window.Behaviors));